module.exports = __webpack_public_path__ + "static/media/ayuhuasca360Loader.eb304d61.jpg";